import { Component, Input, OnInit, OnChanges, SimpleChanges, TemplateRef } from '@angular/core';
import {
  EoViewComponentDescriptor,
  EoViewPanelConfig,
} from 'ngx-eo-web-components';
import { Surgery } from '../../../core/models/surgery.model';
import { SurgeryViewService } from '../../../../services/surgery-view/surgery-view.service';

@Component({
  selector: 'app-surgery-view-panel',
  templateUrl: './app-surgery-view-panel.component.html',
  styleUrls: ['./app-surgery-view-panel.component.scss'],
})
export class AppSurgeryViewPanelComponent implements OnInit, OnChanges {
  @Input() surgery!: Surgery;
  @Input() id: string = 'surgeryViewPanel';
  @Input() name: string = 'Γενικά Στοιχεία Χειρουργείου';
  @Input() columnsNum: number = 4;
  @Input() eoViewComponents: EoViewComponentDescriptor[] = [];
  @Input() headerTemplate?: TemplateRef<any>;
  @Input() isViewOnly: boolean = false;

  config: EoViewPanelConfig = {
    id: this.id,
    name: this.name,
    columnsNum: this.columnsNum,
    viewComponents: [],
  };

  constructor(private surgeryViewService: SurgeryViewService) {}

  ngOnInit(): void {
    this.initializeConfig();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['columnsNum']) {
      this.config.columnsNum = changes['columnsNum'].currentValue;
    }
  }

  private initializeConfig(): void {
    this.config.viewComponents = this.surgeryViewService.generateViewComponents(this.surgery, this.isViewOnly);
    this.config.viewComponents = this.surgeryViewService.addViewComponents(this.config.viewComponents, this.eoViewComponents);
  }
}